import type { FeedbackType } from "~/chat/types/feedback";
import type {
  Conversation,
  ConversationResponse,
} from "~/conversations/types/conversation";

function mapConversationToModel(
  conversation: ConversationResponse,
): Conversation {
  return {
    id: conversation.id,
    title: conversation.title,
    createdAt: new Date(conversation.created_at),
    updatedAt: new Date(conversation.updated_at),
    messages: conversation.messages
      .map((m) => ({
        id: m.id.toString(),
        messageId: m.id,
        content: m.content,
        role: m.role as "user" | "assistant",
        createdAt: m.created_at,
        sources: m.sources
          ? m.sources.map((s) => ({
              type: s.type,
              url: s.url,
              title: s.title,
            }))
          : [],
        feedback: m.feedback
          ? {
              vote: m.feedback.vote as FeedbackType,
              comment: m.feedback.comment,
              tags: m.feedback.tags,
            }
          : undefined,
        attachments: m.attachments
          ? m.attachments.map((a) => ({ filename: a.filename }))
          : [],
      }))
      .sort(
        (a, b) =>
          new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
      ),
  };
}

export { mapConversationToModel };
